import {
  GET_VAT_SETTING_LIST,
  GET_VAT_SETTING_LIST_SUCCESS,
  GET_VAT_SETTING_LIST_FAILED,
  CREATE_VAT_SETTING,
  CREATE_VAT_SETTING_SUCCESS,
  CREATE_VAT_SETTING_FAILED,
  UPDATE_VAT_SETTING,
  UPDATE_VAT_SETTING_SUCCESS,
  UPDATE_VAT_SETTING_FAILED,
} from './actionTypes';

export const actionGetVatSettingList = (payload) => ({
  type: GET_VAT_SETTING_LIST,
  payload,
});

export const actionGetVatSettingListSuccess = (payload) => ({
  type: GET_VAT_SETTING_LIST_SUCCESS,
  payload,
});

export const actionGetVatSettingListFailed = (error) => ({
  type: GET_VAT_SETTING_LIST_FAILED,
  payload: error,
});

export const actionCreateVatSetting = (payload) => ({
  type: CREATE_VAT_SETTING,
  payload,
});

export const actionCreateVatSettingSuccess = (payload) => ({
  type: CREATE_VAT_SETTING_SUCCESS,
  payload,
});

export const actionCreateVatSettingFailed = (error) => ({
  type: CREATE_VAT_SETTING_FAILED,
  payload: error,
});

export const actionUpdateVatSetting = (payload) => ({
  type: UPDATE_VAT_SETTING,
  payload,
});

export const actionUpdateVatSettingSuccess = (payload) => ({
  type: UPDATE_VAT_SETTING_SUCCESS,
  payload,
});

export const actionUpdateVatSettingFailed = (error) => ({
  type: UPDATE_VAT_SETTING_FAILED,
  payload: error,
});
